export const ICONS = {
  INFO: '/assets/svg-icons/icons/info.svg',
  ALERT_CIRCLE: '/assets/svg-icons/icons/alert-circle.svg',
  ALERT_TRIANGLE: '/assets/svg-icons/icons/alert-triangle.svg',
  AIRPLAY: '/assets/svg-icons/icons/airplay.svg',
  ALERT_OCTAGON: '/assets/svg-icons/icons/alert-octagon.svg',
  ALERT_ONLY: '/assets/svg-icons/icons/alert-only.svg',
  ALIGN_CENTER: '/assets/svg-icons/icons/align-center.svg',
  ALIGN_JUSTIFY: '/assets/svg-icons/icons/align-justify.svg',
  ALIGN_LEFT: '/assets/svg-icons/icons/align-left.svg',
  ALIGN_RIGHT: '/assets/svg-icons/icons/align-right.svg',
  ANNOUNCEMENT: '/assets/svg-icons/icons/announcement.svg',
  APERTURE: '/assets/svg-icons/icons/aperture.svg',
  APP_STORE: '/assets/svg-icons/icons/app-store.svg',
  API: '/assets/svg-icons/icons/Api.svg',
  ARROW_DOWN_LEFT: '/assets/svg-icons/icons/arrow-down-left.svg',
  ARROW_DOWN_RIGHT: '/assets/svg-icons/icons/arrow-down-right.svg',
  ARROW_DOWN: '/assets/svg-icons/icons/arrow-down.svg',
  ARROW_LEFT: '/assets/svg-icons/icons/arrow-left.svg',
  ARROW_RIGHT: '/assets/svg-icons/icons/arrow-right.svg',
  ARROW_UP_LEFT: '/assets/svg-icons/icons/arrow-up-left.svg',
  ARROW_UP_RIGHT: '/assets/svg-icons/icons/arrow-up-right.svg',
  ARROW_UP: '/assets/svg-icons/icons/arrow-up.svg',
  AT_SIGN: '/assets/svg-icons/icons/at-sign.svg',  
  ATTACHMENT: '/assets/svg-icons/icons/attachment.svg',
  BAR_CHART_ALT: '/assets/svg-icons/icons/bar-chart-alt.svg',
  BAR_CHART: '/assets/svg-icons/icons/bar-chart.svg',
  BELL: '/assets/svg-icons/icons/bell.svg',
  BILL: '/assets/svg-icons/icons/bill.svg',
  BLUETOOTH: '/assets/svg-icons/icons/bluetooth.svg',
  BOOKMARK: '/assets/svg-icons/icons/bookmark.svg',
  BULLET: '/assets/svg-icons/icons/bullet.svg',
  BOX: '/assets/svg-icons/icons/box.svg',
  CALENDAR: '/assets/svg-icons/icons/calendar.svg',
  CAMERA_OFF: '/assets/svg-icons/icons/camera-off.svg',
  CAMERA: '/assets/svg-icons/icons/camera.svg',
  CHECK_CIRCLE: '/assets/svg-icons/icons/check-circle.svg',
  CHECK_SQUARE: '/assets/svg-icons/icons/check-square.svg',
  CHECK: '/assets/svg-icons/icons/check.svg',
  CHECK_WHITE: '/assets/svg-icons/icons/check-white.svg',
  CHECK_BOX: '/assets/svg-icons/icons/check-box.svg',
  CHECK_ALL: '/assets/svg-icons/icons/check-all.svg',
  CHEVRON_DOWN: '/assets/svg-icons/icons/chevron-down.svg',
  CHEVRON_LEFT: '/assets/svg-icons/icons/chevron-left.svg',
  CHEVRON_RIGHT: '/assets/svg-icons/icons/chevron-right.svg',
  CHEVRON_UP: '/assets/svg-icons/icons/chevron-up.svg',
  CHEVRONS_DOWN: '/assets/svg-icons/icons/chevrons-down.svg',
  CHEVRONS_LEFT: '/assets/svg-icons/icons/chevrons-left.svg',
  CHEVRONS_RIGHT: '/assets/svg-icons/icons/chevrons-right.svg',
  CHEVRONS_UP: '/assets/svg-icons/icons/chevrons-up.svg',
  CLIPBOARD: '/assets/svg-icons/icons/clipboard.svg',
  TABLER_STOPWATCH: '/assets/svg-icons/icons/tabler_stopwatch.svg',
  CLOCK: '/assets/svg-icons/icons/clock.svg',
  CLOSE: '/assets/svg-icons/icons/close.svg',
  CODEPEN: '/assets/svg-icons/icons/codepen.svg',
  COMPASS: '/assets/svg-icons/icons/compass.svg',
  COPY: '/assets/svg-icons/icons/copy.svg',
  CORNER_DOWN_LEFT: '/assets/svg-icons/icons/corner-down-left.svg',
  CORNER_DOWN_RIGHT: '/assets/svg-icons/icons/corner-down-right.svg',
  CORNER_LEFT_DOWN: '/assets/svg-icons/icons/corner-left-down.svg',
  CORNER_LEFT_UP: '/assets/svg-icons/icons/corner-left-up.svg',
  CORNER_RIGHT_DOWN: '/assets/svg-icons/icons/corner-right-down.svg',
  CORNER_RIGHT_UP: '/assets/svg-icons/icons/corner-right-up.svg',
  CORNER_UP_LEFT: '/assets/svg-icons/icons/corner-up-left.svg',
  CORNER_UP_RIGHT: '/assets/svg-icons/icons/corner-up-right.svg',
  CREDIT_CARD: '/assets/svg-icons/icons/credit-card.svg',
  CROP: '/assets/svg-icons/icons/crop.svg',
  DOLLARS: '/assets/svg-icons/icons/dollars.svg',
  DOWNLOAD_CLOUD: '/assets/svg-icons/icons/download-cloud.svg',
  DOWNLOAD: '/assets/svg-icons/icons/download.svg',
  EDIT_COMPOSE: '/assets/svg-icons/icons/edit-compose.svg',
  EDIT_INLINE: '/assets/svg-icons/icons/edit-inline.svg',
  EDIT: '/assets/svg-icons/icons/edit.svg',
  EXPORT: '/assets/svg-icons/icons/export.svg',
  EXTERNAL_LINK: '/assets/svg-icons/icons/external-link.svg',
  EYE_OFF: '/assets/svg-icons/icons/eye-off.svg',
  EYE: '/assets/svg-icons/icons/eye.svg',
  FILE_MINUS: '/assets/svg-icons/icons/file-minus.svg',
  FILE_PLUS: '/assets/svg-icons/icons/file-plus.svg',
  FILE_TEXT: '/assets/svg-icons/icons/file-text.svg',
  FILE_ZIP: '/assets/svg-icons/icons/file-zip.svg',
  FILE: '/assets/svg-icons/icons/file.svg',
  FILTER: '/assets/svg-icons/icons/filter.svg',
  FLAG: '/assets/svg-icons/icons/flag.svg',
  FOLDER: '/assets/svg-icons/icons/folder.svg',
  FULL_SCREEN_ENTER: '/assets/svg-icons/icons/full-screen-enter.svg',
  FULL_SCREEN_EXIT: '/assets/svg-icons/icons/full-screen-exit.svg',
  GLOBE: '/assets/svg-icons/icons/globe.svg',
  GRID: '/assets/svg-icons/icons/grid.svg',
  HASH: '/assets/svg-icons/icons/hash.svg',
  HEART: '/assets/svg-icons/icons/heart.svg',
  HELP_CIRCLE: '/assets/svg-icons/icons/help-circle.svg',
  HISTORY: '/assets/svg-icons/icons/history.svg',
  HOME: '/assets/svg-icons/icons/home.svg',
  IMAGE: '/assets/svg-icons/icons/image.svg',
  INBOX: '/assets/svg-icons/icons/inbox.svg',
  ITALIC: '/assets/svg-icons/icons/italic.svg',
  LAYERS: '/assets/svg-icons/icons/layers.svg',
  LAYOUT: '/assets/svg-icons/icons/layout.svg',
  LIFE_BUOY: '/assets/svg-icons/icons/life-buoy.svg',
  LINK: '/assets/svg-icons/icons/link.svg',
  LIST: '/assets/svg-icons/icons/list.svg',
  LOG_IN: '/assets/svg-icons/icons/log-in.svg',
  LOG_OUT: '/assets/svg-icons/icons/log-out.svg',
  MAIL_OPEN: '/assets/svg-icons/icons/mail-open.svg',
  MAIL: '/assets/svg-icons/icons/mail.svg',
  MAP_PIN: '/assets/svg-icons/icons/map-pin.svg',
  MAP: '/assets/svg-icons/icons/map.svg',
  MAXIMIZE: '/assets/svg-icons/icons/maximize.svg',
  MENU_DOTS: '/assets/svg-icons/icons/menu-dots.svg',
  MENU: '/assets/svg-icons/icons/menu.svg',
  MESSAGE_CIRCLE: '/assets/svg-icons/icons/message-circle.svg',
  MESSAGE_SQUARE: '/assets/svg-icons/icons/message-square.svg',
  MIC: '/assets/svg-icons/icons/mic.svg',
  MINIMIZE: '/assets/svg-icons/icons/minimize.svg',
  MINUS_CIRCLE: '/assets/svg-icons/icons/minus-circle.svg',
  MINUS_SQUARE: '/assets/svg-icons/icons/minus-square.svg',
  MINUS: '/assets/svg-icons/icons/minus.svg',
  MORE_HORIZONTAL: '/assets/svg-icons/icons/more-horizontal.svg',
  MORE_VERTICAL: '/assets/svg-icons/icons/more-vertical.svg',
  MOVE: '/assets/svg-icons/icons/move.svg',
  NAVIGATION: '/assets/svg-icons/icons/navigation.svg',
  PACKAGE: '/assets/svg-icons/icons/package.svg',
  PAPERCLIP: '/assets/svg-icons/icons/paperclip.svg',
  PERCENT: '/assets/svg-icons/icons/percent.svg',
  PHONE_CALL: '/assets/svg-icons/icons/phone-call.svg',
  PHONE_FORWARDED: '/assets/svg-icons/icons/phone-forwarded.svg',
  PHONE_INCOMING: '/assets/svg-icons/icons/phone-incoming.svg',
  PHONE_MISSED: '/assets/svg-icons/icons/phone-missed.svg',
  PHONE_OFF: '/assets/svg-icons/icons/phone-off.svg',
  PHONE_OUTGOING: '/assets/svg-icons/icons/phone-outgoing.svg',
  PHONE: '/assets/svg-icons/icons/phone.svg',
  PIE_CHART: '/assets/svg-icons/icons/pie-chart.svg',
  PLAY_CIRCLE: '/assets/svg-icons/icons/play-circle.svg',
  PLAY: '/assets/svg-icons/icons/play.svg',
  PLUS_CIRCLE: '/assets/svg-icons/icons/plus-circle.svg',
  PLUS_SQUARE: '/assets/svg-icons/icons/plus-square.svg',
  PLUS: '/assets/svg-icons/icons/plus.svg',
  POWER: '/assets/svg-icons/icons/power.svg',
  QR_CODE: '/assets/svg-icons/icons/qr-code.svg',
  REFRESH: '/assets/svg-icons/icons/refresh.svg',
  REPEAT: '/assets/svg-icons/icons/repeat.svg',
  RESIZER: '/assets/svg-icons/icons/resizer.svg',
  ROTATE_CCW: '/assets/svg-icons/icons/rotate-ccw.svg',
  ROTATE_CW: '/assets/svg-icons/icons/rotate-cw.svg',
  RUPEES: '/assets/svg-icons/icons/rupees.svg',
  SAVE: '/assets/svg-icons/icons/save.svg',
  SEARCH: '/assets/svg-icons/icons/search.svg',
  SEND: '/assets/svg-icons/icons/send.svg',
  SERVER: '/assets/svg-icons/icons/server.svg',
  SETTINGS: '/assets/svg-icons/icons/settings.svg',
  SHARE: '/assets/svg-icons/icons/share.svg',
  SHIELD: '/assets/svg-icons/icons/shield.svg',
  SHOPPING_CART: '/assets/svg-icons/icons/shopping-cart.svg',
  SHUFFLE: '/assets/svg-icons/icons/shuffle.svg',
  SIDEBAR: '/assets/svg-icons/icons/sidebar.svg',
  SLASH: '/assets/svg-icons/icons/slash.svg',
  SLIDERS: '/assets/svg-icons/icons/sliders.svg',
  SMARTPHONE: '/assets/svg-icons/icons/smartphone.svg',
  SQUARE: '/assets/svg-icons/icons/square.svg',
  STAR: '/assets/svg-icons/icons/star.svg',
  TABLET: '/assets/svg-icons/icons/tablet.svg',
  TAG: '/assets/svg-icons/icons/tag.svg',
  THUMBS_DOWN: '/assets/svg-icons/icons/thumbs-down.svg',
  THUMBS_UP: '/assets/svg-icons/icons/thumbs-up.svg',
  TOGGLE_LEFT: '/assets/svg-icons/icons/toggle-left.svg',
  TOGGLE_RIGHT: '/assets/svg-icons/icons/toggle-right.svg',
  TRASH: '/assets/svg-icons/icons/trash.svg',
  TRENDING_DOWN: '/assets/svg-icons/icons/trending-down.svg',
  TRENDING_UP: '/assets/svg-icons/icons/trending-up.svg',
  TRIANGLE: '/assets/svg-icons/icons/triangle.svg',
  TYPE: '/assets/svg-icons/icons/type.svg',
  UNDERLINE: '/assets/svg-icons/icons/underline.svg',
  UPLOAD_CLOUD: '/assets/svg-icons/icons/upload-cloud.svg',
  UPLOAD: '/assets/svg-icons/icons/upload.svg',
  USER_CHECK: '/assets/svg-icons/icons/user-check.svg',
  USER_MINUS: '/assets/svg-icons/icons/user-minus.svg',
  USER_PLUS: '/assets/svg-icons/icons/user-plus.svg',
  USER_X: '/assets/svg-icons/icons/user-x.svg',
  USER: '/assets/svg-icons/icons/user.svg',
  USERS: '/assets/svg-icons/icons/users.svg',
  VIDEO_OFF: '/assets/svg-icons/icons/video-off.svg',
  VIDEO: '/assets/svg-icons/icons/video.svg',
  VOICEMAIL: '/assets/svg-icons/icons/voicemail.svg',
  WIFI_OFF: '/assets/svg-icons/icons/wifi-off.svg',
  WIFI: '/assets/svg-icons/icons/wifi.svg',
  X_CIRCLE: '/assets/svg-icons/icons/x-circle.svg',
  X_SQUARE: '/assets/svg-icons/icons/x-square.svg',
  ZAP: '/assets/svg-icons/icons/zap.svg',
  ZOOM_IN: '/assets/svg-icons/icons/zoom-in.svg',
  ZOOM_OUT: '/assets/svg-icons/icons/zoom-out.svg',
  HEADPHONES: '/assets/svg-icons/icons/_headphones.svg',
  CHAT: '/assets/svg-icons/icons/chat.svg',
  USER_SOLID: '/assets/svg-icons/icons/user-solid.svg',   
  BELL_ICON: 'assets/svg-icons/icons/bell-icon.svg',   
  EXA_AI: 'assets/svg-icons/icons/exa-ai.svg',
  AI_CHAT_USER: 'assets/svg-icons/icons/ai-chat-user.svg',
  SIDEBAR_LEFT: 'assets/svg-icons/icons/sidebar-left.svg',
  SIDEBAR_RIGHT: 'assets/svg-icons/icons/sidebar-right.svg',
  WARNING: 'assets/svg-icons/icons/warning.svg',
  PLAY_FILLED: 'assets/svg-icons/icons/play - filled.svg',
  ALERT_ONLY_FILLED: 'assets/svg-icons/icons/alert-only-filled.svg',
  CIRCLE: 'assets/svg-icons/icons/circle.svg',
  USER_CLOCK: 'assets/svg-icons/icons/user-clock.svg',
  USER_RECALL: 'assets/svg-icons/icons/user-recall.svg',
  CC_CLOCK: 'assets/svg-icons/icons/cc-clock.svg',
  SHIELD_SOLID: 'assets/svg-icons/icons/shield-solid.svg',
  CAR: 'assets/svg-icons/icons/car.svg',
  LOCK_OFF: 'assets/svg-icons/icons/lock-off.svg',
  LOCK_ON: 'assets/svg-icons/icons/lock-on.svg',
  LOCK_OFF_FILLED: 'assets/svg-icons/icons/lock-off-filled.svg',
  FILE_SEARCH: 'assets/svg-icons/icons/file-search.svg',
  ICON_LOG: 'assets/svg-icons/icons/icon-log.svg',
  ICON_SVG: 'assets/svg-icons/icons/icon_tags.svg',
  LOCK_ON_FILLED: 'assets/svg-icons/icons/lock-on-filled.svg',
  GEMINI_AI: 'assets/svg-icons/icons/gemini-ai.svg',
  CONFETTI: 'assets/svg-icons/icons/confetti.svg',
  ADD_PAGE: 'assets/svg-icons/icons/add-page.svg',
  SHARE_IOS: 'assets/svg-icons/icons/share-ios.svg',
  EXCEL_COLOR: 'assets/svg-icons/icons/excel_color.svg',
};